export default {
  ONBOARDING_REQUIRED: "ONBOARDING_REQUIRED",
  ONBOARDING_REVIEW: "ONBOARDING_REVIEW",
  EXTERNAL_ACCOUNT_REQUIRED: "EXTERNAL_ACCOUNT_REQUIRED",
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  DELETED: "DELETED"
};
